<template>
  <div  :class="className" :style="{height:height,width:width}"/>
</template>

<script>
  import * as echarts from 'echarts'
  // import {getHistoryBusiness} from '@/api/tenant/report'

  require('echarts/theme/macarons') // echarts theme
  // import resize from './mixins/resize'

  export default {
    // mixins: [resize],
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '400px'
      }
    },
    data() {
      return {
        chart: null,
        type:1,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      // chatBtn(params){
      //   var that =this
      //   // window.open('https://www.baidu.com/s?wd=' + encodeURIComponent(params.name));
      //   switch (params.name) {
      //     case '沉睡':
      //       this.type=1;
      //       break;
      //     case '普通':
      //       this.type=2;
      //       break;
      //     case '活跃' :
      //       this.type=3;
      //       break;
      //     default :
      //       break;
      //   }
      //   that.$emit("btn",that.type)
      // },

      initChart() {
        this.$http.get('/wechat/api.agent.data/storeLiveness'
        ).then(response => {
          console.log('response', response);
          this.data = response.data.data.live;
          this.www=  Number(this.data.active)+Number(this.data.normal)+Number(this.data.sleep)
          this.chart = echarts.init(this.$el, 'macarons')
          // this.chart.on('click', (params)=> {
          //   var that =this
          //   that.chatBtn(params)
          //
          // });
          this.chart.setOption({
            graphic: [
              {
                type: 'group',
                left: '70%',
                top:'3px',
                bottom: 130,
                margin:"0 0 0 5px",

                children: [
                  {
                    type: 'text',
                    style: {
                      fill: '#333',
                      text: [
                        '总商户数:'+this.www
                      ].join('\n'),
                      font: '14px Microsoft YaHei',
                    }
                  }
                ]
              }
            ],

            title: {
              show: true,
              text: "商户活跃度占比分析",
              x: "35%",
              y:'-2',
              textStyle: {
                fontFamily: 'Arial, Verdana, sans...',
                fontSize: 30,
                fontStyle: 'normal',
                fontWeight: 'normal',
              }
            },

            tooltip: {
              triggerOn: 'click',
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            grid: {

              width:"20%", //图例宽度
              height:"100%", //图例高度

              containLabel: true
            },
            legend: {
              left: '27%',
              top: '25',
              data: ['活跃', '普通', '沉睡']
            },

            series: [
              {
                name: '商户活跃度所占比例',
                type: 'pie',
                roseType: 'radius',
                radius: "50%",
                center: ['50%', '46%'],
                data: [
                  {value: this.data.active, name: '活跃'},
                  {value: this.data.normal, name: '普通'},
                  {value: this.data.sleep, name: '沉睡'}
                ],
                animationEasing: 'cubicInOut',
                animationDuration: 2600
              }
            ]
          });

        })

      }

    }
  }
</script>

